import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { colors } from 'ui/theme/colors';

export const Redshift = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Redshift"
    height={height}
    width={width}
    viewBox="0 0 512 512"
    title="Redshift logo"
    titleId="redshift-logo-title"
    {...props}
  >
    <g fill={colors.black}>
      <path d="M256,391.5l194.7,46.4V73.1L256,119.5L256,391.5z" fill="#205B97" />
      <path
        d="M450.7,73.1l37.1,18.5v327.6l-37.1,18.5V73.1z M256,391.5L61.3,437.8V73.1L256,119.5V391.5z"
        fill="#205B97"
      />
      <path d="M61.3,73.1L24.2,91.7v327.6l37.1,18.5V73.1z" fill="#205B97" />
      <path d="M305.5,512l74.2-37.1V37.1L305.5,0l-22.7,243.1L305.5,512z" fill="#5193CE" />
      <path d="M206.5,512l-74.2-37.1V37.1L206.5,0l22.7,243.1L206.5,512z" fill="#205B97" />
      <path d="M206.5,0h99.9v511h-99.9L206.5,0z" fill="#2E73B7" />
    </g>
  </SvgIcon>
);
